<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import IconRefreshCw from '~icons/lucide/refresh-cw';

import { UiAppPage, UiButton, UiEmptyState } from '@ohmybible/ui';

/** A failure the page cannot recover from by itself (API down, new release). */
const props = defineProps<{
  title: string;
  description: string;
}>();

const { t } = useI18n();

const reload = () => {
  window.location.reload();
};
</script>

<template>
  <UiAppPage data-testid="error-screen">
    <UiEmptyState
      role="alert"
      :heading-level="1"
      :title="props.title"
      :description="props.description"
    >
      <template #actions>
        <UiButton
          variant="soft"
          :icon="IconRefreshCw"
          data-testid="error-screen-reload"
          @click="reload"
        >
          {{ t('common.reload') }}
        </UiButton>
      </template>
    </UiEmptyState>
  </UiAppPage>
</template>
